import { render, staticRenderFns } from "./cenario.vue?vue&type=template&id=64eeedf4&"
import script from "./cenario.js?vue&type=script&lang=js&"
export * from "./cenario.js?vue&type=script&lang=js&"
import style0 from "./cenario.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports